import * as moment from 'moment'

export class TimeRangeMoment {
  start: moment.Moment;
  end: moment.Moment;
  label: string;
  constructor(start: moment.Moment, end: moment.Moment, label?: string) {
    this.start = start;
    this.start
    this.end = end;
    if (label) {
      this.label = label;
    }
  }
}